import { RootState } from 'editor/src/store/index';

import getSessionImages from './getSessionImages';

const getSessionImagesCount = (state: RootState) => getSessionImages(state).length;

export default getSessionImagesCount;
